// extracted by mini-css-extract-plugin
export default {"border":"ServiceCustomer_border__uc27p","wrapper":"ServiceCustomer_wrapper__oAJBe","label":"ServiceCustomer_label__zdS1e"};